<div class="modal-content-container">
    <span class="material-symbols-outlined error-icon">error</span>
    <h2>{{ data.modalHeading || 'Regional Alert!' }}</h2>
    <div class="messages-container">
        @for(msg of data.responseForDisplay | keyvalue; track msg.key){
            <div>
                @if(msg.key && msg.value){
                       <h4>{{ msg.key }}</h4>
                       <p>{{ msg.value }}</p>
               }
           </div>
        }
    </div>
    @if(data.emphasizedText){
        <p class="emphasized-text">{{ data.emphasizedText }}</p>
    }
    <div class="button-container">
        @if(data.showLeftButton){
            <button mat-raised-button (click)="buttonClicked('left')" class="left-button" >{{ data.leftButtonLabel || 'Select New Plan'}} </button>
        }
        <button mat-raised-button color="primary" (click)="buttonClicked('right')" class="right-button" >{{ data.rightButtonLabel || 'Acknowledge' }} </button>  
    </div>
</div>

